import { useNavigate } from 'react-router-dom';
import imageCompression from 'browser-image-compression';
import { message } from 'antd';

const handleCancel = () => {
  const navigate = useNavigate();
  navigate('/companylist/');
};

const beforeUpload = async (file, itemName) => {
  // Validate file type
  const isJpgOrPng = ['image/jpeg', 'image/png', 'image/jpg'].includes(
    file.type,
  );

  if (!isJpgOrPng) {
    message.error('Only JPG, JPEG, and PNG files are allowed!');
    return false; // Prevents file from being added
  }

  // File size limit (500 KB)
  const maxSizeKB = 500;
  if (file.size / 1024 <= maxSizeKB) {
    // Rename and return file if it's already under 500 KB
    return renameFile(file, itemName);
  }

  try {
    // Compression options
    const options = {
      maxSizeMB: 0.5, // 500 KB limit
      maxWidthOrHeight: 1024, // Resize if necessary
      useWebWorker: true,
    };

    const compressedFile = await imageCompression(file, options);
    return renameFile(compressedFile, itemName); // Rename compressed file and return
  } catch (error) {
    console.error('Compression error:', error);
    message.error('Image compression failed!');
    return false; // Prevent upload
  }
};

// Function to rename file
const renameFile = (file, itemName) => {
  const extension = file.name.split('.').pop(); // Extract file extension
  const newFileName = `${itemName}_${Date.now()}.${extension}`;

  return new File([file], newFileName, { type: file.type });
};

// const onPreview = async (file) => {
//   let src = file.url;
//   if (!src) {
//     src = await new Promise((resolve) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file.originFileObj);
//       reader.onload = () => resolve(reader.result);
//     });
//   }
//   const image = new Image();
//   image.src = src;
//   const imgWindow = window.open(src);
//   imgWindow?.document.write(image.outerHTML);
// };
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const imageOnChange = ({ fileList: newFileList }, formData, setFormData) => {
  const filteredFiles = newFileList?.filter(
    (file) =>
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg',
  );
  setFormData({
    ...formData,
    fileList: filteredFiles,
  });
};
const customRequest = ({ onSuccess }) => {
  onSuccess('done');
};

const onPreview = async (file, setPreviewImage, setPreviewOpen) => {
  if (!file.url && !file.preview) {
    file.preview = await getBase64(file.originFileObj);
  }

  setPreviewImage(file.url || file.preview);
  setPreviewOpen(true);
};

const onRemove = (file, formData, setFormData, form) => {
  setFormData({ ...formData, image: null, fileList: [] });
};

const normFile = (e) => {
  if (!e || !e.fileList || e.fileList.length === 0) {
    return null;
  }
  if (Array.isArray(e)) {
    return e.file;
  }
  return e.file;
};

const goToCompanyEditForm = (id) => {
  return `/company/${id}/edit/`;
};

export {
  handleCancel,
  normFile,
  onPreview,
  goToCompanyEditForm,
  onRemove,
  beforeUpload,
  imageOnChange,
  customRequest,
};
